<template>
  <div id="AcademicResources">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>
    <usc-intro :copy="this.intro"></usc-intro>
   <!-- <usc-videoEmbed :frameTitle="this.video.frameTitle" :caption="this.video.caption" :videoSource="this.video.src"></usc-videoEmbed> -->
    <div class="body gutter-lg mb">
      <address>
        <strong>Academic Calendar</strong><br />
        <a href="https://www.usc.edu/academic-calendar/" class="inline-hyperlink" target="_blank">https://www.usc.edu/academic-calendar/</a><br />
      </address>

      <address>
        <strong>USC Bookstore</strong><br />
        840 Childs Way<br />
        <a href="https://uscbookstore.com" class="inline-hyperlink" target="_blank">https://uscbookstore.com</a><br />
        (800) 447-8620
      </address>

      <p><strong>Catalogue</strong><br />The <a href="https://catalogue.usc.edu/" class="inline-hyperlink" target="_blank">USC Catalogue</a> in effect for the semester of your admission is the authoritative reference for ensuring you meet all Marshall and university requirements for graduation. Degree requirements listed in the USC Catalogue supersede information in any other university or school publication. </p>
      <p><strong>OASIS</strong><br />This powerful online student-information tool lets you check your completed course list, grades, enrollment status, payment status (including balance due and specific charges) and change your address for all USC departments.</p>
      <usc-cta text="Log in to OASIS" url="https://usc.edu/OASIS"></usc-cta>
      <p>Use your USC ID number and six-digit birth date (“mmddyy” format).</p>
      <p><strong>Schedule of Classes</strong><br />USC’s Schedule of Classes provides semester-specific registration instructions, tuition and fees, course listings and more.<br /><a href="https://classes.usc.edu" class="inline-hyperlink" target="_blank">https://classes.usc.edu</a></p>

      <address>
        <strong>Transcripts</strong><br />
        Hubbard Hall Lobby<br />
        <a href="https://arr.usc.edu/records-transcripts/transcripts/" class="inline-hyperlink" target="_blank">https://arr.usc.edu/records-transcripts/transcripts/</a><br />
        (213) 740-7445
      </address>

    </div>
  </div>
</template>

<script>

import hero from '@/components/Hero'
import intro from '@/components/Intro'
import cta from '@/components/Cta'
import videoEmbed from '@/components/videoEmbed'
import linkGroup from '@/components/LinkGroup'

export default {
  name: 'AcademicResources',
  components: {
    'usc-hero': hero,
    'usc-intro': intro,
    'usc-cta': cta,
    'usc-videoEmbed': videoEmbed,
    'usc-linkGroup': linkGroup
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Academic Resources',
        loResSrc: '../../../static/HeroImages/Marshall118.jpg',
        hiResSrc: '../../../static/HeroImages/Marshall118.jpg'
      },
      intro: [
        'There are many resources available to you at USC and within USC Marshall. This section lists and details some key primary sources to consult when you need support.'
      ],
      video: {
        caption: 'Dean Ellis answers questions from students',
        src: 'https://player.vimeo.com/video/249455387?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Dean Ellis answers questions'
      },
      linkGroups: {
        0: {
          title: 'Websites',
          links: [
            {
              text: 'USC',
              url: 'https://www.usc.edu/'
            },
            {
              text: 'USC Marshall',
              url: 'https://www.marshall.usc.edu/'
            }
          ]
        },
        1: {
          title: 'Helpful Web Links',
          links: [
            {
              text: 'Academic Calendar',
              url: 'https://academics.usc.edu/calendar/academic-calendar-2018-2019/'
            },
            {
              text: 'Athletics',
              url: 'http://usctrojans.com/'
            },
            {
              text: 'Bookstore',
              url: 'https://www.uscbookstore.com/'
            },
            {
              text: 'Catalogue',
              url: 'http://catalogue.usc.edu/'
            },
            {
              text: 'Class Schedule',
              url: 'http://classes.usc.edu/'
            },
            {
              text: 'Center for Black Cultural and Student Affairs',
              url: 'https://cbcsa.usc.edu/'
            },
            {
              text: 'El Centro Chicano',
              url: 'http://sait.usc.edu/elcentro/'
            },
            {
              text: 'Financial Aid',
              url: 'https://financialaid.usc.edu/'
            },
            {
              text: 'Housing',
              url: 'http://housing.usc.edu/'
            },
            {
              text: 'Marshall Mashup (Current Student Blogs)',
              url: 'http://marshallmashup.usc.edu'
            },
            {
              text: 'OASIS',
              url: 'https://usc.edu/OASIS'
            },
            {
              text: 'Orientation',
              url: 'https://orientation.usc.edu/'
            },
            {
              text: 'Recreational Sports',
              url: 'https://sait.usc.edu/recsports/'
            },
            {
              text: 'Student Health Center',
              url: 'http://engemannshc.usc.edu/'
            },
            {
              text: 'Student Organizations',
              url: 'http://campusactivities.usc.edu/'
            },
            {
              text: 'Transportation Services',
              url: 'http://transnet.usc.edu/'
            },
            {
              text: 'Undergraduate Admissions',
              url: 'http://admit.usc.edu/'
            },
            {
              text: 'Volunteer Center',
              url: 'http://campusactivities.usc.edu/'
            }
          ]
        }
      }
    }
  },
  created () {
    this.$root.setPageHeader('Resources', 'Academic Resources')
  }
}
</script>
<style scoped lang="scss">
  @import '~styles/vars';
  #c5-wrapper {
    h4 {
      margin-bottom: 10px;
    }
    address {
      margin-bottom: 25px;
      font-style: normal;
    }
    .resources-link {
      color: $cBody;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/resources/AcademicResources.vue